export default __webpack_public_path__ + "static/media/service2.c125bbe4.png";